import {Component} from 'react';
import {observe} from 'mobx';
import {inject, observer} from 'mobx-react';

@inject('store')
@observer
class ScrollRestoration extends Component {
  componentDidMount() {
    const {router} = this.props.store;

    // Takes ownership of any scroll changes from Chrome:
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    this.disposeObserver = observe(router, 'currentPath', this.handlePathChange);
    window.addEventListener('popstate', this.handlePopstate);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopstate);
    this.disposeObserver();
  }

  render() {
    return this.props.children || null;
  }

  /**
   * Executes either before or after the path change
   * and only if the popstate event was fired
   */
  handlePopstate = () => {
    const {ui} = this.props.store;
    ui.shouldScrollBeRestoredForNextRoute = true;
  };

  /**
   * Executes after the path change
   */
  handlePathChange = change => {
    const {ui} = this.props.store;

    // The old view is still around, so a snapshot
    // of its scroll position can be taken:
    ui.saveScrollFor(change.oldValue);

    ui.shouldScrollBeRestored = new Promise(resolve => {
      // Tackle the handlePopstate/handlePathChange
      // race condition:
      window.setTimeout(() => {
        resolve(ui.shouldScrollBeRestoredForNextRoute);
        ui.shouldScrollBeRestoredForNextRoute = false;
      });
    });
  };
}

export default ScrollRestoration;
